<template lang="pug">
.best-selling-stat
  .px-4.py-2.mt-3
    .text-title.ml-2 สถิติยอดขายสินค้า
    .d-flex.justify-content-center
      GenericCard(size='40')
        GraphBestSellingProductGroup.m-3(:groupsData="bestSellingsChartData")
      div
        ProfilePerformanceStatItem(
          title='ค่าคอมมิชชั่น'
          :value='totalCommission'
          color='#E02020'
          size='33'
          :iconSrc='require(`@/assets/icons/investment.svg`)'
        )
        ProfilePerformanceStatItem(
          title='ยอดขาย'
          :value='total'
          size='33'
          :iconSrc='require(`@/assets/icons/profits.svg`)'
        )
</template>

<script>
import ProfilePerformanceStatItem from '@/components/profile-performance/ProfilePerformanceStatItem.vue';
import GraphBestSellingProductGroup from '@/components/GraphBestSellingProductGroup.vue';

export default {
  props: {
    bestSellingsChartData: {
      default: () => [],
    },
    totalCommission: {
      default: '...',
    },
    total: {
      default: '...',
    },
  },
  watch: {},
  components: {
    ProfilePerformanceStatItem,
    GraphBestSellingProductGroup,
  },
};
</script>

<style lang="scss">
// .best-selling-stat {}
</style>
